import { PrintKitPage } from "@wedding/print-kit";
import { useWedding } from "../contexts/wedding-context";

const WEB_BASE =
  (import.meta.env.VITE_WEB_BASE_URL as string | undefined)?.replace(/\/$/, "") ?? "http://localhost:5173";

/**
 * Ortak "Baskı" sayfasının ince adaptörü — tek kaynak `@wedding/print-kit`;
 * organizatör ve admin aynı kartları üretir (QR = buildScanUrl(WEB_BASE, slug)).
 */
export function PrintPage() {
  const { wedding, slug } = useWedding();
  return <PrintKitPage slug={slug} wedding={wedding} webBaseUrl={WEB_BASE} />;
}
